import { magentoApi } from "./magentoApi";

export function fetchCustomer() {
  return magentoApi.get("customers/me");
}
